const borders = {
    radius: '2px',
};

export default borders;


